import { __assign } from "tslib";
// DS: I51
import React from 'react';
import IconWrap from '../../IconWrap';
import { useFlag } from '../../../redux/flags/hooks';
var Notification = function (props) {
    return useFlag('action_icons_update3') ? (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M15 19a2 2 0 01-2 2h-2a2 2 0 01-2-2h6zM13 2a1 1 0 011 1v1h2.656c.429 0 .835.41.907.917L19 13l1.707 1.707a1 1 0 01.293.707V17a1 1 0 01-1 1H4a1 1 0 01-1-1v-1.586a1 1 0 01.293-.707L5 13l1.437-8.083C6.51 4.41 6.915 4 7.344 4H10V3a1 1 0 011-1h2z" })))) : (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null,
                React.createElement("path", { d: "M11.8286 15.999A2.995 2.995 0 0112 17.0008c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-.3513.0604-.6885.1714-1.0018h5.6572zM9 0c3.3323 0 7 2.5 7 7v4l1 2h1v2H0v-2h1l1-2V7c0-4.5 3.6677-7 7-7z" })))));
};
Notification.displayName = 'Notification';
export default Notification;
//# sourceMappingURL=Notification.js.map